<!--
  --
  -- エラー概要を表示するコンポーネント
  --
  -->
<template>
  <div class="text-center">
    <p class="display-4 mb-0">SORRY!</p>
    <h1 class="display-1 font-weight-thin mb-8">{{caption}}</h1>
    <p class="subtitle-2 text--secondary">ERROR {{code}}</p>
  </div>
</template>

<script>
export default {
  name: 'CHeader',
  props: {
    /**
     * エラーコード
     */
    code: {
      type: [Number, String],
      required: true
    },

    /**
     * エラータイトル
     */
    caption: {
      type: String,
      required: true
    }
  }
}
</script>
